<template>
    <div class="main-width">
        <div class="location_css">
            <img src="../../assets/img/location.png">
            <div>当前位置：</div>
            <div @click="goSy()">首页</div>
            <div> <i class="el-icon-arrow-right"></i> </div>
            <div>产品追溯</div>
            <div> <i class="el-icon-arrow-right"></i> </div>
            <div class="location_text">{{selectData.restaurantName}}</div>
        </div>
        <div class="culture_main" v-loading="loading">
            <div class="culture_left">
                <div class="culture_left_title">产品追溯</div>
                <div>
                    <div class="culture_left_item" v-for="(item,index) in storeList" :key="index" @click="select(item)">
                        <div style="display: flex;">
                            <div class="culture_left_item_text" :class="{'culture_active':item.id == selectData.id}">
                                <i class="el-icon-caret-right" style="margin-right: 9px"></i>{{item.restaurantName}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="culture_right">
                <div class="culture_right_title">
                    <div class="culture_right_text">
                        <img src="../../assets/img/jiujia.png" style="width: 19px;height: 21px;">
                        <div>{{selectData.restaurantName}}</div>
                    </div>
                </div>
                <div class="company_item">
                    <div style="min-height:129px;">
                        <img class="company_img" align="left" :src="selectData.imagesPath">
                        <div>
                            <div class="company_title">酒家简介</div>
                            <div class="company_content">{{selectData.description}}</div>
                        </div>
                    </div>
                    <!--酒家产品-->
                    <div>
                        <div class="company_title">酒家产品</div>
                        <div class="company_product">
                            <div class="tshj_item product_item" @click="goDetail(item)" v-for="(item,index) in productList" :key="index" style="margin-right: 14px ;">
                                <img :src="item.wineImage" style="width: 200px;height: 259px;">
                                <div style="margin-top: 15px;margin-bottom: 15px;">{{item.wineName}}</div>
                            </div>
                        </div>
                    </div>
                    <!--酒家轶事-->
                    <div>
                        <div class="company_title">酒家轶事</div>
                        <div class="company_content">{{selectData.restaurantAnecdote}}</div>
                    </div>
                    <!--酒家特色-->
                    <div>
                        <div class="company_title">酒家特色</div>
                        <div class="company_content">{{selectData.restaurantFeature}}</div>
                    </div>
                    <!--酿造历史-->
                    <div>
                        <div class="company_title">酿造历史</div>
                        <div class="company_content">{{selectData.restaurantHistory}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            storeList: [],
            loading: false,
            selectData: {},
            productList: []
        }
    },
    methods: {
        //跳转到详情
        goDetail: function(data) {
            this.$router.push({
                path: "/productdetail",
                query: {
                    id: this.selectData.id,
                    companyname: data.restaurantName,
                    wineid: data.wineId
                }
            });
        },
        //获取所有商家
        getAllStore: function() {
            let vue = this;
            return new Promise((resolve, reject) => {
                this.$axios.get("fx-web/wine/restaurant", { params: { pageNum: 1, pageSize: 10000 } }).then(function(resp) {
                    if (resp.errcode == 0 || resp.errcode == "0") {
                        vue.storeList = resp.data.dataList;
                    };
                    resolve();
                }, function() {
                    resolve();
                });
            });
        },
        //获取商家简介等信息
        getOasis: function(entityId) {
            var vue = this;
            return new Promise((resolve, reject) => {
                this.$axios.get("oasis/em-entity/detail/" + entityId).then(function(resp) {
                    if (resp.status == 0 || resp.status == "0") {
                        vue.selectData["description"] = resp.data.description;
                    } else {
                        vue.$message.warning(resp.msg);
                    };
                    vue.loading = false;
                    resolve();
                }, function() {
                    vue.loading = false;
                    resolve();
                    vue.$message.warning("操作失败");
                });
            });

        },
        //获取商家产品
        getProduct: function() {
            let vue = this;
            this.$axios.get("fx-web/wine/page/wine", { params: { Id: this.selectData.id, pageNum: 1, pageSize: 10000 } }).then(function(resp) {
                if (resp.errcode == 0 || resp.errcode == "0") {
                    vue.productList = resp.data.dataList;
                } else {
                    vue.$message.warning(resp.errtext);
                };
                vue.loading = false;
            }, function() {
                vue.loading = false;
            });
        },
        //选择酒家
        select: function(data) {
            var vue = this;
            this.selectData = data;
            this.getOasis(data.entityId).then(function() {
                vue.getProduct();
            });
        }
    },
    mounted() {
        let vue = this;
        vue.loading = true;
        this.getAllStore().then(function() {
            vue.select(vue.storeList[0]);
        }).then(vue.getProduct);
    }
}
</script>